export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif"];

export const MAX_IMAGE_SIZE = 512 * 1025; // 512 KB
